<template>
  <v-expansion-panels>
    <v-expansion-panel>
      <v-expansion-panel-title>История документа</v-expansion-panel-title>
      <v-expansion-panel-text>
        <div v-for="(item, index) in history" :key="index">
          <div>
            <div class="time">{{ item.messageDate }}</div>
            <div class="header">{{ item.messageHeader }}</div>
            <div class="message">{{ item.message }}</div>
          </div>
          <v-divider class="border-opacity-100" v-if="index != (history.length - 1)" />
        </div>
      </v-expansion-panel-text>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
export default {
  props: {
    history: Array
  }
};
</script>
<style scoped>
.time {
  font-size: 10pt;
  color: #000;
  opacity: 0.5;
}

.header {
  font-size: 12pt;
  color: darkslateblue;
}

.message {
  font-size: 12pt;
  border: none;
}
</style>